"use client"

import React from "react"
import { useParams } from "react-router-dom"
import { useRestaurantAuth } from "../contexts/RestaurantAuthContext"
import RestaurantProfilePage from "../pages/restaurant/RestaurantProfilePage"
import StaffProfilePage from "../pages/restaurant/StaffProfilePage"

const ProfileRoute: React.FC = () => {
  const { restaurantId } = useParams()
  const { isOwner } = useRestaurantAuth()

  // Show owner profile page for restaurant owners, staff profile for staff users
  if (isOwner) {
    return <RestaurantProfilePage />
  } else {
    return <StaffProfilePage />
  }
}

export default ProfileRoute


